/**
 * Product Variation Picker
 * Handles visual feedback for multi-dimensional product matrix selection
 */

class ProductVariationPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const link = e.target.closest(
        "a[data-option-1], a[data-option-2], a[data-option-3]"
      );
      if (!link) return;

      // Prevent navigation for disabled options
      if (
        link.classList.contains("is-disabled") ||
        link.getAttribute("aria-disabled") === "true"
      ) {
        e.preventDefault();
        return;
      }

      // Update visual feedback before page reload
      const fieldset = link.closest("[data-option-position]");
      if (fieldset) {
        fieldset
          .querySelectorAll("a")
          .forEach((el) => el.classList.remove("is-selected"));
        link.classList.add("is-selected");

        const selectedValueSpan = fieldset.querySelector(
          "[data-selected-value]"
        );
        if (selectedValueSpan) {
          const label =
            link.querySelector("span:not(.sr-only)")?.textContent ||
            link.getAttribute("aria-label") ||
            "";
          selectedValueSpan.textContent = label;
        }
      }
    });
  }
}

if (!window.customElements.get("product-variation-picker")) {
  window.customElements.define(
    "product-variation-picker",
    ProductVariationPicker
  );
}
